import { Component } from '@angular/core';
import { BusinessAreaModel } from '../business-area.model';
import { ItemViewContainerBase } from '@fi-app/core/item-view-container-base';

@Component({
    selector: 'fi-business-area-view-container',
    template: '<fi-business-area-view [businessArea]="businessArea"></fi-business-area-view>',
    styleUrls: ['./business-area-view-container.component.scss'],
    standalone: false,
})
export class BusinessAreaViewContainerComponent extends ItemViewContainerBase {
    businessArea: BusinessAreaModel;
}
